import React from 'react'
import ReactDOM from 'react-dom'
import './styles/index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import LogRocket from 'logrocket';
//require('dotenv').config();

if (process.env.REACT_APP_DEPLOYED_BOOLEAN === 'true') {
  console.log("Initializing LogRocket");
  LogRocket.init('asmfeb/legalpulse');
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
